module.exports = __webpack_public_path__ + "img/school.1b331260.png";